import {
  PaymentMethodCardListResponse,
  PaymentMethodCardResponse,
} from "@API/src/component/memoruHome/paymentMethod/types";
import { MessageOkResponse } from "chaild-entity/src/component/memoruHome/cart/types";

export const isTypePaymentMethodCardListResponse = (
  arg
): arg is PaymentMethodCardListResponse =>
  arg !== null &&
  typeof arg === "object" &&
  Array.isArray(arg) &&
  (arg.length === 0 || isTypePaymentMethodCardResponse(arg[0]));

export const isTypePaymentMethodCardResponse = (
  arg
): arg is PaymentMethodCardResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as PaymentMethodCardResponse).cardSeq === "string" &&
  typeof (arg as PaymentMethodCardResponse).cardNo === "string" &&
  typeof (arg as PaymentMethodCardResponse).expire === "string" &&
//  typeof (arg as PaymentMethodCardResponse).holderName === "string";
  (typeof (arg as PaymentMethodCardResponse).holderName === "string" || (arg as PaymentMethodCardResponse).holderName === null)

export const isTypeMessageOkResponse = (arg): arg is MessageOkResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as MessageOkResponse).message === "string";
